import type { ReactNode } from "react";
import { LockKeyhole } from "lucide-react";
import { Navigate, useLocation } from "react-router-dom";

import { useSession } from "../context/SessionContext";
import { PageError, PageLoader } from "./StateViews";

export function CustomerGate({ children }: { children: ReactNode }) {
  const { status, error, refresh, customerLoginPending, startCustomerLogin } = useSession();
  if (status === "loading") return <PageLoader label="Checking your Next-Cart session…" />;
  if (status === "authenticated") return <>{children}</>;
  if (status === "error") return <PageError message={error ?? "Your session could not be checked."} onRetry={() => void refresh()} />;
  return (
    <section className="auth-gate card">
      <span className="auth-gate__icon"><LockKeyhole aria-hidden="true" size={25} /></span>
      <div>
        <p className="eyebrow">Next-Cart account</p>
        <h1>Sign in to continue</h1>
        <p>Use your existing Next-Cart account. You do not need a separate support password.</p>
      </div>
      <button className="button button--primary" type="button" disabled={customerLoginPending} onClick={startCustomerLogin}>{customerLoginPending ? "Signing in…" : "Sign in with Next-Cart"}</button>
    </section>
  );
}

export function StaffGate({ children }: { children: ReactNode }) {
  const { status, user } = useSession();
  const location = useLocation();
  if (status === "loading") return <div className="full-screen-state"><PageLoader label="Opening your workspace…" /></div>;
  if (status !== "authenticated" || user?.kind !== "staff") {
    return <Navigate to="/agent/login" replace state={{ from: location.pathname }} />;
  }
  if (user.mfaSetupRequired && location.pathname !== "/agent/settings") {
    return <Navigate to="/agent/settings?enroll-mfa=1" replace />;
  }
  if (user.passwordChangeRequired && location.pathname !== "/agent/settings") {
    return <Navigate to="/agent/settings?change-password=1" replace />;
  }
  return <>{children}</>;
}
